export var toAbsoluteUrl = function (pathname) { return process.env.PUBLIC_URL + pathname; };
